const isCountry = (countryCode: string) => process.env.NEXT_PUBLIC_COUNTRY_IDENTIFIER === countryCode

export default isCountry
